import {useState} from 'react';
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const SpecialPermissionApp = () => {
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { getSpecialPermissionAssigned, countSpecialPermissionAssigned } = useSelector((state) => state?.UserSpecialPermissionSlice);
    const { t } = useTranslation();
    const [results, setResults] = useState(null);
    const assigned = getSpecialPermissionAssigned?.totalElements || countSpecialPermissionAssigned || 0;

    return {
        DEV,
        permission,
        t,
        results,
        setResults,
        assigned
    }

}

export default SpecialPermissionApp
